import { colorTokens, radiusTokens, typographyTokens } from '../../app/designTokens';

const { semantic } = colorTokens;

/** Wizard card rail width from Figma (Trial & Onboarding / Current). */
export const REGISTER_WIZARD_MAX_WIDTH = 920;

export const REGISTER_CARD_SX = {
  p: { xs: 2, md: 2.5 },
  bgcolor: semantic.bg.input,
  border: `1px solid ${semantic.border.subtle}`,
  borderRadius: `${radiusTokens.md}px`,
  backgroundImage: 'none',
};

export const REGISTER_SECTION_TITLE_SX = {
  fontFamily: typographyTokens.fontFamilyDisplay,
  fontWeight: typographyTokens.fontWeightBold,
  fontSize: 16,
  color: semantic.text.primary,
};

export const REGISTER_LABEL_SX = {
  fontFamily: typographyTokens.fontFamily,
  fontSize: 13,
  color: semantic.text.secondary,
};

export const REGISTER_HELPER_SX = {
  fontFamily: typographyTokens.fontFamily,
  fontSize: 12,
  color: semantic.text.muted,
};

export const REGISTER_VALUE_SX = {
  fontFamily: typographyTokens.fontFamily,
  fontSize: 14,
  color: semantic.text.primary,
};

/** Figma selectable card (ModuleCard / UserTierCard / BillingPeriodCard / AdditionalServiceCard). */
export function selectableCardSx(selected) {
  return {
    m: 0,
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    alignItems: 'flex-start',
    gap: 1,
    px: 1.5,
    py: 1.25,
    borderRadius: `${radiusTokens.md}px`,
    border: `1px solid ${selected ? semantic.status.brand.border : semantic.border.subtle}`,
    bgcolor: selected ? semantic.bg.surfaceSelected : semantic.bg.surface,
    transition: 'background-color 120ms ease, border-color 120ms ease',
    '&:hover': {
      borderColor: selected ? semantic.status.brand.border : semantic.border.default,
    },
  };
}

export function formatRegisterAmount(amount, currency, t) {
  if (amount === null || amount === undefined) {
    return t('common:empty_value');
  }
  return t('pricing:currency_amount', { amount, currency: currency || 'EUR' });
}
